import React from "react";
import { useTranslation } from "react-i18next";
import TitleComponent from "../../../global/Custom/TitleComponent/TitleComponent";
import WordformForm from "./WordformForm";

function WordformCretae() {
    const {t} = useTranslation()
  return (
    <div>
      <TitleComponent title={t('add')} isExist={false} />
      <WordformForm/>
    </div>
  );
}

export default WordformCretae;
